const storageKey = (reportId) => `report-run:${reportId}`;

export function saveReportRun(reportId, payload) {
  if (!reportId) return;
  try {
    sessionStorage.setItem(storageKey(reportId), JSON.stringify({
      ...payload,
      savedAt: Date.now(),
    }));
  } catch (err) {
    // Ignore quota / private-mode failures; the report can be re-run.
  }
}

export function loadReportRun(reportId) {
  if (!reportId) return null;
  try {
    const raw = sessionStorage.getItem(storageKey(reportId));
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
}

export function clearReportRun(reportId) {
  if (!reportId) return;
  try {
    sessionStorage.removeItem(storageKey(reportId));
  } catch (err) {
    // ignore
  }
}
